import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()

/**
 * Clase que define el estado de cargando
 *
 * *Class that defines loading state*
 *
 */
export class LoadingService {

  /**
   * Definición de clase Subject
   *
   * *Subject Class Definition*
   */
  private subject = new Subject<any>();

  /**
   * Inicializar loadingState como un Observable de subject
   *
   * *Set loadingState as observable subject*
   */
  loadingState = this.subject.asObservable();

  /**
   * Función para actualizar el estado de cargando en true
   *
   * *Function to update loading state to true*
   */
  show() {
    this.subject.next(true);
  }

  /**
   * Función para actualizar el estado de cargando en false
   *
   * *Function to update loading state to false*
   */
  hide() {
    this.subject.next(false);
  }
}
